var r = Object.defineProperty;
var n = (t, o, s) => o in t ? r(t, o, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[o] = s;
var e = (t, o, s) => n(t, typeof o != "symbol" ? o + "" : o, s);
class a extends Error {
  constructor(s) {
    super(s);
    e(this, "location");
    this.location = s;
  }
}
export {
  a as UnauthorizedResponse
};
